export default __webpack_public_path__ + "static/media/miguel-lopes-3.d33e0a80.jpg";